module.exports = __webpack_public_path__ + "static/media/Barmag 5a1.873dbf75.jpg";